import React from "react";
import { Switch, Route } from "react-router-dom";
import PrivateInquiryList from "./PrivateInquiryList";
import ViewPrivateInquiry from "./ViewPrivateInquiry";

const privateInquiry = () => (
  <Switch>
    <Route
      exact
      component={PrivateInquiryList}
      path='/artisans-moderation/private-inquiry'
    />
    <Route
      exact
      component={ViewPrivateInquiry}
      path='/artisans-moderation/private-inquiry/:id'
    />
  </Switch>
);

export default privateInquiry;
